import SEO from "@/components/SEO";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { HERO_IMAGES } from "@/lib/constants";
import CtaBand from "./home/CtaBand";
import PartnersTeaser from "./home/PartnersTeaser";

export default function About() {
  return (
    <>
      <SEO
        title="Despre noi — un proiect, un contact, o soluție | BROX CONSTRUCT"
        description="Brox Construct conectează clientul, echipele de execuție și furnizorii într-un singur sistem. Construcțiile sunt complicate — găsirea oamenilor potriviți nu ar trebui să fie."
        path="/despre-noi"
      />

      <section className="grain bg-ink-950 pb-10 pt-28 sm:pb-24 sm:pt-40">
        <div className="container-brox">
          <Reveal><p className="eyebrow mb-5">DESPRE NOI</p></Reveal>
          <Reveal delay={0.08}>
            <h1 className="display-title max-w-4xl text-4xl sm:text-6xl lg:text-7xl" data-testid="about-title">
              Construcțiile sunt complicate. <span className="text-copper">Găsirea oamenilor potriviți nu ar trebui să fie.</span>
            </h1>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-7 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg" data-testid="about-copy">
              Brox Construct conectează clientul, echipele de execuție și furnizorii într-un singur sistem.
              Un proiect poate primi execuție proprie sau prin firmele partenere potrivite, iar materialele pot
              veni din rețeaua noastră de furnizori — totul coordonat dintr-un singur punct.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="relative border-y border-white/10">
        <img src={HERO_IMAGES.about} alt="Echipe Brox Construct pe șantier" loading="lazy" className="h-[46vh] w-full object-cover sm:h-[60vh]" data-testid="about-image" />
        <div className="absolute inset-0 flex items-center justify-center bg-ink-950/55 px-6" aria-hidden="false">
          <Reveal>
            <p className="display-title max-w-4xl text-center text-4xl sm:text-6xl lg:text-7xl" data-testid="about-statement">
              Un proiect. Un contact. <span className="text-copper">O soluție.</span>
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-ink-950 py-14 sm:py-28" data-testid="about-model-section">
        <div className="container-brox">
          <SectionHeading eyebrow="CUM GÂNDIM" title="Modelul Brox" />
          <div className="mt-12 grid gap-px border border-white/10 bg-white/10 md:grid-cols-3">
            {[
              { nr: "01", title: "Un proiect", text: "Privim lucrarea ta ca pe un proiect întreg — nu ca pe o listă de meseriași de găsit separat." },
              { nr: "02", title: "Un contact", text: "Un singur interlocutor care îți răspunde, coordonează echipele și răspunde de rezultat." },
              { nr: "03", title: "O soluție", text: "Echipa potrivită, materialele potrivite, în ordinea corectă a lucrărilor — din rețeaua Brox." },
            ].map((item, i) => (
              <Reveal key={item.nr} delay={0.08 * i} className="bg-ink-900">
                <div className="flex h-full flex-col gap-3 p-6 sm:p-10">
                  <span className="font-mono text-sm text-copper">{item.nr}</span>
                  <h3 className="display-title text-2xl sm:text-3xl">{item.title}</h3>
                  <p className="text-sm leading-relaxed text-muted-foreground">{item.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <p className="mt-10 max-w-3xl text-base leading-relaxed text-muted-foreground">
              Unele proiecte sunt executate de echipele noastre, altele prin firmele partenere din rețea — în
              funcție de specificul lucrării, zonă și termen. Indiferent cine execută, coordonarea rămâne la
              fel de simplă pentru tine: un singur contact.
            </p>
          </Reveal>
        </div>
      </section>

      <PartnersTeaser />
      <CtaBand />
    </>
  );
}
